export default {"src":"/_next/static/media/bid.7d468881.svg","height":62,"width":61,"blurWidth":0,"blurHeight":0};